import { render, staticRenderFns } from "./NewPhysician.vue?vue&type=template&id=bcf78b2c&scoped=true&"
import script from "./NewPhysician.vue?vue&type=script&lang=js&"
export * from "./NewPhysician.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf78b2c",
  null
  
)

export default component.exports